/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector, batch } from 'react-redux';
import { setSiteProductsToV2 } from 'state/slices/account';
import { updateMigrationStatus } from 'state/thunks/migration';
import { DATA_MIGRATION_READY } from 'utils/consts/migration';
// utils
// material
import { Button, displayModal, log } from '@insticator/insticator-ui';
import { ReactComponent as UpgradeIcon } from 'assets/icons/upgrade.svg'
// content
import MigrationModal from '../migrationmodal/migrationmodal';
// styles
import injectSheet from "react-jss";
import styles from './activatemigration_styles';
import { setSitesWithProductsV2 } from 'state/slices/migration';
import { updateCurrentPage } from 'state/slices/app';

/* ========== ~~~~~~~~~~ MIGRATION STATUS WIDGET : ACTIVATE ~~~~~~~~~~ ========== */
const ActivateMigration = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const { siteUUID } = useSelector(state => state.session);
  const { migrationStatus, sitesWithProductsV2, isMigrationUpdating } = useSelector(state => state.migrationStatus)
  const adminEmail = useSelector(state => state.session.userEmail);

  const activateMigration = useCallback(async () => {
    const response = await dispatch(updateMigrationStatus({
      siteId: siteUUID,
      data: {
        currentStatus: migrationStatus,
        adminEmail
      }
    }))
    log('response', response)
    // if migration update is success, set products to 2.0 and add it on the sites with products 2.0
    if (response.payload && response.payload.migrationStatus && response.payload.migrationStatus === DATA_MIGRATION_READY) {
      dispatch(setSiteProductsToV2())
      dispatch(setSitesWithProductsV2([...new Set([...sitesWithProductsV2, siteUUID])]))
      dispatch(displayModal(true, <MigrationModal migrationStatus={DATA_MIGRATION_READY} />))
      dispatch(updateCurrentPage('/dashboard/productmanager'))
    }
  }, [dispatch, siteUUID])

  return (
    <div className={`activatemigration ${props.classes.activatemigration}`}>
      <div className='info'>
        <span className='icon'><UpgradeIcon height={30} width={30} /></span>
        <p className='text'>Upgrade to Commenting 2.0</p>
      </div>
      <Button text={'Activate'} processing={isMigrationUpdating} processingText={'Activating..'} handleClick={activateMigration} />
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ActivateMigration